// extracted by mini-css-extract-plugin
export default {"visually_hidden":"OngoingMarker_visually_hidden__fRy+a","isOnGoing":"OngoingMarker_isOnGoing__4BvKp","isOnGoing_marker":"OngoingMarker_isOnGoing_marker__CYgKm"};